import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Flex, Typography, Image, Divider, Button, Spin, Avatar, Empty, Form } from 'antd';
import { DollarOutlined, EnvironmentOutlined, CalendarOutlined, LoadingOutlined } from '@ant-design/icons';
import { JobDetailModal } from '../JobDetailModal';
import { NavLink, useSearchParams } from 'react-router-dom';
import { MySelect, MyInput } from '../../PageComponents';
import { useDispatch, useSelector } from 'react-redux';
import { actionsApi } from '../../../shared/redux/actionsApi';
import { services } from '../../../shared';
import moment from 'moment';
import { apiCalls } from '../../../shared/Apis'

const { Title, Text, Paragraph } = Typography;

const RightFindjoblayout = ({ setJobId }) => {
    const { form } = Form.useForm()
    const [searchParams] = useSearchParams();
    const [detailModal, setDetailModal] = useState(false);
    const [expanded, setExpanded] = useState(false);
    const [ servicelookup, setServiceLookup ] = useState([])
    const [searchName, setSearchName] = useState(searchParams.get('name') || '');
    const [searchLocation, setSearchLocation] = useState(searchParams.get('location') || '');

    const dispatch = useDispatch();
    const { jobData, loadJob, filters, pagination } = useSelector((state) => state?.jobgetapi);

    // one time call api when we receive text from searchparams
    useEffect(() => {
        if (searchParams.get('name') || searchParams.get('location')) {
            dispatch(
                actionsApi?.getJobAllDetail({
                    ...filters,
                    name: searchParams.get('name') || '',
                    location: searchParams.get('location') || '',
                    pageNo: 1,
                    pageSize: 20,
                })
            );
        }
    }, []);

    // searchhandler function
    const searchHandler = (pageNo = 1, pageSize = 20) => {
        dispatch(
            actionsApi?.getJobAllDetail({
                ...filters,
                name: searchName,
                location: searchLocation,
                pageNo,
                pageSize,
            })
        );
    };

    // when you clear search inputs then call searchhandler function
    useEffect(() => {
        if (!searchName && !searchLocation) {
            searchHandler();
        }
    }, [searchName, searchLocation]);


    useEffect(()=>{
        getService()
    },[])

    const getService = async () => {
        let result= await apiCalls?.serviceApi?.getService()
        if(result)
        setServiceLookup(result)
    }
    return (
        <div className="mt-3 mb-3">
            <Form
                layout='vertical'
                form={form}
            >
                <Row gutter={[24, 24]} align={'bottom'} justify={'center'}>
                    <Col lg={{ span: 7 }} md={{ span: 10 }} xs={{ span: 24 }} sm={{ span: 24 }}>
                        <MySelect
                            label='Services'
                            name='services'
                            message='Please enter services'
                            options={servicelookup}
                        />
                    </Col>
                    <Col lg={{ span: 7 }} md={{ span: 10 }} xs={{ span: 24 }} sm={{ span: 24 }}>
                        <MyInput
                            label='Location'
                            name='location'
                            placeholder='Town'
                            suffix={<img src='/assets/icons/location.png' width={16} />}
                            value={searchLocation}
                            onChange={(e) => setSearchLocation(e.target.value)}
                        />
                    </Col>
                    <Col lg={{ span: 4 }} md={{ span: 4 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                        <Button className="btn" onClick={() => searchHandler()}>
                            Search
                        </Button>
                    </Col>
                </Row>
            </Form>
            <Row gutter={[16, 16]} justify={'center'}>
                {loadJob ? (
                    <Col span={24}>
                        <Flex justify="center" align="center" className="h-100 w-100 mt-3">
                            <Spin indicator={<LoadingOutlined className="text-brand" spin />} size="large" />
                        </Flex>
                    </Col>
                ) : jobData?.length === 0 ? (
                    <Col span={24}>
                        <Flex justify="center" align="center" className="h-100 w-100 mt-3">
                            <Empty description="No data found" />
                        </Flex>
                    </Col>
                ) : (
                    jobData?.map((data, index) => (
                        <Col sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 8 }} xl={{ span: 6 }} key={index}>
                            <Card className="card-pro mt-3 h-100">
                                <Row gutter={[16, 16]}>
                                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 18 }} lg={{ span: 24 }}>
                                        <Flex gap={10} className="w-100 flex-mbl" justify='center'>
                                            <Avatar
                                                size={64}
                                                src={
                                                    <Image
                                                        src={data?.image}
                                                        width={65}
                                                        height={65}
                                                        style={{ objectFit: 'cover' }}
                                                        preview={false}
                                                    />
                                                }
                                            />
                                            <Flex vertical className="" gap={4}>
                                                <Title level={4} className="m-0 text-brand">
                                                    {data?.service?.name}
                                                </Title>
                                                <Title level={5} className="m-0 text-gray">
                                                    {data?.organizationName?.charAt(0).toUpperCase() +
                                                        data?.organizationName?.slice(1)}
                                                </Title>
                                            </Flex>
                                        </Flex>
                                    </Col>
                                    <Col span={24}>
                                        <Paragraph
                                            ellipsis={{
                                                rows: 2,
                                                expandable: 'collapsible',
                                                symbol: expanded ? 'less' : 'more',
                                                onExpand: () => setExpanded(!expanded),
                                            }}
                                            className="text-gray mt-3"
                                        >
                                            {data?.description}
                                        </Paragraph>
                                    </Col>
                                    <Col xs={{ span: 20 }} sm={{ span: 20 }} md={{ span: 19 }} lg={{ span: 20 }}>
                                        <Flex vertical className="w-100" gap={3}>
                                            <Text className="fs-14">
                                                <EnvironmentOutlined /> &nbsp;{' '}
                                                {data?.location?.charAt(0).toUpperCase() + data?.location?.slice(1)}
                                            </Text>
                                            <Text className="fs-14">
                                                <DollarOutlined />&nbsp; ${data?.budget} month
                                            </Text>
                                            <Text className="fs-14">
                                                <CalendarOutlined />&nbsp; {moment(data?.date).format('YYYY-MM-DD')}
                                            </Text>
                                        </Flex>
                                    </Col>
                                    <Divider className="m-0" />
                                    <Col span={24}>
                                        <Flex justify="center" className="w-100" align="center">
                                            <NavLink to={'/applyproform'} className="btn fs-14 fw-400 p-1" onClick={() => setJobId(data?.id)}>
                                                Apply Now
                                            </NavLink>
                                        </Flex>
                                    </Col>
                                </Row>
                            </Card>
                        </Col>
                    ))
                )}
            </Row>
            <JobDetailModal visible={detailModal} onClose={() => setDetailModal(false)} />
        </div>
    );
};

export { RightFindjoblayout };
